import { render, staticRenderFns } from "./SendToTcModal.vue?vue&type=template&id=304ea7b9&"
import script from "./SendToTcModal.vue?vue&type=script&lang=js&"
export * from "./SendToTcModal.vue?vue&type=script&lang=js&"
import style0 from "./SendToTcModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports